import { ReactNode } from 'react';
import { ColorFieldConfigurator } from './FieldConfigurators/ColorFieldConfigurator';
import { ReadonlyFieldConfigurator } from './FieldConfigurators/ReadonlyFieldConfigurator';
import { SimpleFieldConfigurator } from './FieldConfigurators/SimpleFieldConfigurator';
import { FieldData } from './fieldDelegationUtils';

export interface AttributeConfiguratorProps {
  attributeName: string;
  defaultText: string;
  fieldData: FieldData;
  currentValue: any;
  errors: Record<string, string>;
  actionSlot?: ReactNode;
  currentProductTypeId?: string;
}

export const AttributeFieldDelegator: React.FC<AttributeConfiguratorProps> = ({
  attributeName,
  defaultText,
  fieldData,
  currentValue,
  errors,
  actionSlot,
  currentProductTypeId,
}) => {
  if (fieldData.type === 'color') {
    return (
      <ColorFieldConfigurator
        attributeName={attributeName}
        label={defaultText}
        options={fieldData.options}
        currentValue={currentValue}
        actionSlot={actionSlot}
      />
    );
  }

  if (fieldData.type === 'toggle') {
    return (
      <SimpleFieldConfigurator
        attributeName={attributeName}
        label={defaultText}
        options={fieldData.options}
        currentValue={currentValue}
        fieldType="radio-selector"
        errors={errors}
        actionSlot={actionSlot}
      />
    );
  }

  if (fieldData.type === 'readonly') {
    return (
      <ReadonlyFieldConfigurator
        attributeName={attributeName}
        label={defaultText}
        options={fieldData.options}
        currentValue={currentValue}
        errors={errors}
        actionSlot={actionSlot}
      />
    );
  }

  return (
    <SimpleFieldConfigurator
      attributeName={attributeName}
      label={defaultText}
      options={fieldData.options}
      currentValue={currentValue}
      fieldType="select"
      errors={errors}
      actionSlot={actionSlot}
      currentProductTypeId={currentProductTypeId}
    />
  );
};
